import React, { useContext } from "react";
import { FontAwesome } from "../../../../../Components/FontAwesome";
import { SubHeader } from "../../../../../Components/SubHeader";
import { Table } from "../../../../../Components/Table";
import Profile from "../../../../../contexts/profile";

import { translate } from "../../../../../utils/globalFunctions";

export function ListOptimizations(props) {
  const { profile } = useContext(Profile);

  const tableParams = [
    {
      key: "name",
      label: translate("Name", profile.language),
      filter: "text",
      placeholder: translate("Type the name", profile.language),
    },
    {
      key: "data.customer",
      label: translate("Customer", profile.language),
      filter: "text",
      params: "name",
      placeholder: translate("Type the customer name", profile.language),
    },
    {
      key: "data.simulation",
      label: translate("Simulation", profile.language),
      filter: "text",
      params: "nome",
      placeholder: translate("Type the simulation name", profile.language),
    },
    {
      key: "status",
      type: "status",
      label: "Status",
      filter: "status",
      style: { width: 100 },
    },
  ];
  return (
    <>
      <SubHeader
        {...props}
        title={translate("Optimization", profile.language)}
        route="optimization"
        newLabel={translate("New Optimization", profile.language)}
        newLink="/optimizator/create"
        breadcrumbs={[
          { label: translate("Basic Registration", profile.language) },
          {
            label: translate("Optimization List", profile.language),
          },
        ]}
        icon={<FontAwesome type="solid" name="bars" size="24" color="#fff" />}
      />

      <Table
        cols={tableParams}
        editLink={"/optimizator/edit/"}
        emptyText={translate("No items found!", profile.language)}
        route={"optimization/"}
        {...props}
      />
    </>
  );
}
